<template>
    <div>
        <table class="table table-bordered table-striped datatable display responsive no-wrap" width="100%" id="datatable">
            <thead>
            <tr>
                <th>Fecha de alta</th>
                <th></th>
                <th>Vehículo</th>
                <th>Agente</th>
                <th>Provincia</th>
                <th>Precio</th>
                <th>Kilometros</th>
                <th>Matrícula</th>
                <th>Color</th>
                <th>Vista previa</th>
            </tr>
            </thead>
            <tfoot>
            <tr>
                <th>Fecha de alta</th>
                <th></th>
                <th>Vehículo</th>
                <th>Agente</th>
                <th>Provincia</th>
                <th>Precio</th>
                <th>Kilometros</th>
                <th>Matrícula</th>
                <th>Color</th>
                <th>Vista previa</th>
            </tr>
            </tfoot>
        </table>
    </div>
</template>

<script>
import 'datatables.net-bs'
import 'datatables.net-responsive-bs'
import moment from 'moment'

export default {
  name: 'Datatable',
  mounted () {
    let self = this
    // noinspection JSUnresolvedFunction
    // noinspection JSUnusedGlobalSymbols
    window.datatable = window.$('#datatable').dataTable({
      lengthChange: false,
      responsive: {
        details: false
      },
      bSort: true,
      language: {
        'sProcessing': 'Buscando resultados…',
        'aDataSort': 'Ordenar por',
        'sLengthMenu': 'Mostrar _MENU_ registros',
        'sZeroRecords': 'No se encontraron resultados',
        'sEmptyTable': 'Ningún dato disponible en esta tabla',
        'sInfo': 'Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros',
        'sInfoEmpty': `Mostrando registros del 0 al 0 de un total de 0 registros`,
        'sInfoFiltered': '(filtrado de un total de _MAX_ registros)',
        'sInfoPostFix': '',
        'sSearch': 'Buscar:',
        'sUrl': '',
        'sType': 'tipo',
        'sInfoThousands': ',',
        'sLoadingRecords': `Buscando resultados…`,
        'oPaginate': {
          'sFirst': 'Primero',
          'sLast': 'Último',
          'sNext': 'Siguiente',
          'sPrevious': 'Anterior'
        },
        'oAria': {
          'sSortAscending': ': Activar para ordenar la columna de manera ascendente',
          'sSortDescending': ': Activar para ordenar la columna de manera descendente'
        }
      },
      processing: true,
      serverSide: true,
      search: {
        delay: 5000
      },
      searchDelay: 800,
      columns: [
        { data: 'publicationSort', orderable: true },
        { data: 'color.name', orderable: false },
        { data: 'fullText', orderable: false },
        { data: 'dealer.email', orderable: false },
        { data: 'dealership.province.name', orderable: false },
        { data: 'price', orderable: true },
        { data: 'kilometers', orderable: true },
        { data: 'plate', orderable: false },
        { data: 'color.name', orderable: false },
        { data: 'thumbnail', orderable: false }
      ],
      ajax: {
        url: `${process.env.API_ENDPOINT}/v1/car/search/datatable`,
        beforeSend: request => {
          request.setRequestHeader('Authorization', `Bearer ${self.$store.state.app.session.token}`)
        },
        complete: response => {
          if (response.status === 200) {
          } else {
            this.error = response.responseText
          }
        }
      },
      rowCallback: (row, data) => {
        let cellPublicationSort = row.cells[0]
        let cellPrice = row.cells[5]
        let cellThumbnail = row.cells[9]
        let cellLocation = row.cells[3]
        let cellEdit = row.cells[1]

        if (data.hasOwnProperty('publicationSort')) {
          cellPublicationSort.innerHTML = moment(data.publicationSort * 1000).format('YYYY-MM-DD HH:mm:ss')
        }

        cellPrice.innerHTML = `${data.price} €`
        cellThumbnail.width = '150px'
        cellThumbnail.style.textAlign = 'center'
        cellThumbnail.style.padding = 0
        cellThumbnail.innerHTML = `<img src="${process.env.PICTURE_ENDPOINT}/${data.thumbnail}" style="max-width:150px; max-height: 120px; margin: 0 auto;" />`

        cellLocation.style.textAlign = 'center'
        cellLocation.innerHTML = `<a href="mailto:${data.dealer.email}">${data.dealer.email}</a><br/>${data.dealership.name}`

        cellEdit.style.textAlign = 'center'
        cellEdit.classList.add('cellEdit')
        cellEdit.style.verticalAlign = 'center'
        cellEdit.innerHTML = `<a href="/#/cars/${data.code}/edit"><i class="fa fa-edit"></i><span>Editar</span></a>`

        // row.addEventListener('click', () => {
        //   this.$emit('onCarClicked', data)
        // })
      }
    })
  }
}
</script>

<style lang="scss">
    @import 'datatables.net-bs/css/dataTables.bootstrap.min.css';

    #datatable_wrapper {
        img {
            max-width: 150px;
            @media(max-width: 768px) {
                max-width: 50px !important;
            }
        }
        .row:nth-child(1) .col-sm-6:nth-child(1) {
            display:none !important;
        }
        .dataTables_filter {
            text-align: left;
        }
    }

    .cellEdit {
        a {
            text-decoration: none;
            color: #1fabe2;
        }
    }

</style>



// WEBPACK FOOTER //
// src/components/datatables/PublicationCarsDatatable.vue